export default __webpack_public_path__ + "static/so-white-c00e443505e8be1ad7d989a1e1f82c4f.png";